import React from 'react';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import ComponentName from '../constant/ComponentName';
import CollectionNames from '../constant/CollectionNames';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { RootState } from '../redux/store';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import { changePageFilter } from '../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import AiModelListViewerComponent from '../components/ai/AiModelListViewerComponent';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import AiModelService from '../service/AiModelService';
import { MLOpsModel } from '../domain/mlops/MLOpsDomains';
import { MLOpsModelSchema } from '../domain/mlops/MLOpsSchemaDomains';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class AiModelContainer extends StandardContainerComponent<Props, State, MLOpsModel, MLOpsModelSchema> {
  private readonly aiModelService: AiModelService = ServiceContainer.getInstance().get(ServiceNames.AI_MODEL);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.AI_MODEL,
      withSchema: true,
      itemCollection: CollectionNames.AI_MODELS,
      label: LanguageUtil.get({ id: 'common.label.aiModels', defaultMessage: 'Ai Models' }),
    };
    super(props, args);
  }

  protected async prepareCount(): Promise<void> {
    const count = await this.aiModelService.count(this.getCountFilter().build());
    this.setState({ totalRecord: count });
  }

  protected getListView(): React.ReactNode {
    const { items, permissions, itemBuilderView } = this.state;
    return (
      <AiModelListViewerComponent
        aiModels={items}
        views={itemBuilderView?.getListViews()}
        currentModal={itemBuilderView?.getLastCurrent()}
        openAiModel={this.openComponent}
        onSortChange={this.onSortChange}
        permissions={permissions}
      />
    );
  }

  private getAiModelsFromModal(): string[] {
    const {
      component: { selectedComponentIds },
    } = this.props;
    return selectedComponentIds.map((aiModel: MLOpsModel) => aiModel.name);
  }

  protected async deployAll(): Promise<BulkActionDependencyError[]> {
    return await this.aiModelService.bulkAction(this.getAiModelsFromModal(), 'Deploy');
  }

  protected async undeployAll(): Promise<BulkActionDependencyError[]> {
    return await this.aiModelService.bulkAction(this.getAiModelsFromModal(), 'Undeploy');
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    return await this.aiModelService.bulkAction(this.getAiModelsFromModal(), 'Remove');
  }
}

class State {}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  categoryPages: state.category.pages,
  activePageIndex: state.page.activePageIndex,
  enrichedCategories: state.page.enrichedCategories,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});
const mapDispatchToProps = { setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(AiModelContainer));
